const axios = require('axios')

module.exports.getSales = async (store, cpf) => {
  const attendentsList = await axios.get(`https://rosaazul.painel.magazord.com.br/api/v2/site/pedido?cpfCnpj=${cpf}`, {
    headers: {
      Authorization: 'Basic YjYwNTMwMzE0NDAzZTZkNDhiOTljZTc0ZWVjNDhlM2RhOGRhODg0MmQxZGYyZTlhMmRjZWZiMjY5NWYwNjljMTowbzIzSmwhRQ==',
    },
  }).then(resp => resp.data)
  return attendentsList
}

module.exports.getCustomers = async (data_min, data_max, page, uuid) => {
  const customerList = await axios.get(`https://notification.manyconvert.com/clientes/cadastrados/${uuid}?min_data=${data_min}&max_data=${data_max}&page=${page}`)
    .then(resp => resp.data)
  console.log(customerList.customers)
  return customerList.customers
}

module.exports.getLinkCart = async (uuid, cartId) => {
  const getCartInfos = await axios.get(`https://abandonedcart.manyconvert.com/${uuid}/cart/${cartId}`)
    .then(resp => resp.data)

  return getCartInfos.link
}
